<template>
  <div class="sidebar-offerlist">
    <div class="offers-list">
      <div v-if="offers.length==0">
        No Promotions Found
      </div>
      <div v-else
        class="offer-item panel panel"
        v-for="(offer, index) in offers"
        :key="index"
        @click="()=>selectOffer(offer)"
        :class="{
          'offer-selected': ((selectedOffer?.offer_id||userAppliedOffer) === offer?.offer_id),
        }"
      >
        <div class="item">
          <input type="radio" name="offer" :checked="((selectedOffer?.offer_id||userAppliedOffer)== offer.offer_id)" :id="offer.offer_id"/>
           <p>{{ offer.name }}</p>
        </div>
          <!-- Show choice options if 'choiceOption' exists -->
          <div v-if="offer.choiceOption&& selectedOffer?.offer_id==offer.offer_id">
            <label>Select an option:</label>
            <select v-model="selectedChoice" class="form-control">
              <option
                v-for="(choice, key) in offer.choiceOption"
                :value="key"
                :key="key"
              >
                {{ choice }}
              </option>
            </select>
          </div>

          <!-- multiple option  -->
          <div v-if="offer.selectOption && selectedOffer?.offer_id == offer.offer_id" class="checkbox-container">
            <label class="select-label">Choose Product(s)</label>
            <!-- <label class="select-label">Select an option:</label> -->
            <div class="checkbox-group">
              <div v-for="(choice, key) in offer.selectOption" :key="key" class="checkbox-item">
                <input
                  type="checkbox"
                  :value=parseInt(key)
                  v-model="selectedMultipleChoice"
                  :id="'option-'+key" 
                  :checked="selectedMultipleChoice.includes(key)"
                />
                <label :for="'option-' + key" class="checkbox-label">{{ choice }}</label>
              </div>
            </div>
            <!-- <div class="selected-options">
              <strong>Selected Options:</strong> {{ selectedMultipleChoice.join(', ') }}
            </div> -->
          </div>
      </div>
    </div>

    <div :class="props.type=='custom' ?'custom-apply-button-container': 'apply-button-container'">
        <!-- style="position: absolute;
        bottom: -5px;
        left: 50%;
        padding: 0px 12px;
        height: 50px;
        width: 200px;
        border-radius: 10px;
        transform: translateX(-50%); -->
      <button style="padding: 0px 12px;height: 50px;border-radius: revert-layer;"
        class="btn btn-primary"
        @click="applySelectedOffer"
        :disabled="!isOfferValid() || disableBtn"
        >
        <!-- v-show="(props.type === 'custom' && (isOfferValid() || disableBtn)) || !props.type === 'custom'" -->
        Apply Offer
      </button>
      <button class="btn btn-invert" @click="closePanel"
        >Skip</button>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed,defineEmits } from "vue";
import useAuthenticatedApi from "@/plugins/useAuthenticatedApi";
import eventBus from "@/utils/eventBus";
import { useCartStore } from "@/stores/cart";
import { useUserStore } from "@/stores/userStore";
import { showToast } from "@/utils/toaster";
const { offerService } = useAuthenticatedApi();
const offers = ref([]);
const selectedOffer = ref(null); // Store the selected offer
const selectedChoice = ref(null); // Store the selected choice for choice-based offers
const selectedMultipleChoice = ref([]); // Store the selected choice for choice-based offers
const disableBtn = ref(null);
const cartStore = useCartStore();
const userStore = useUserStore();
let cartItems = computed(() => cartStore.cartItems);
let userAppliedOffer = computed(() => cartStore.getAppliedOffer);
let cartDetail = computed(() => userStore.cartDetail);
const props = defineProps({
  type:{
    type:String,
    required:false,
  },
  validate: {
    type: String,
    required: false,
  }
});
const emit = defineEmits(["updatePromotionsCount","closeEvent"]);
const promotionsCount = computed(() => offers.value.length);
const downline = computed(() => {
  const userDownline = cartStore.getUserDownline;
  return (userDownline && userDownline.length > 0) ? userDownline : null;
});
const closePanel=()=>{
  emit('closeEvent',true);
  if(eventBus.panelClose){
    eventBus.panelClose()
  }
}
const mca_no = computed(() => {
  return downline.value ? downline.value : userStore.mcano;
});
// Fetch offers on component mount

// let pointsProducts = computed(()=>cartItems.value.reduce((total, item) => {
//         return item.detail.cv ? total + item.quantity : total;
//       }, 0));
      
  function getUpdatedPrice(item) {
    const originalPrice = parseFloat(item.price).toFixed(2);
    if (item.detail?.cv && item.detail?.cp_price) {
    
    // const feePerItem = 100 / pointsProducts.value;
    const feePerItem = 1;

    return parseFloat(feePerItem).toFixed(2) ;
    // return feePerItem * item.quantity;
    }
    return originalPrice;
  }
// Select offer (single select only)
function selectOffer(offer) {
    selectedOffer.value = offer;
    if (offer.choiceOption) {
      // selectedChoice.value = Object.keys(offer.choiceOption)[0]; // Select first option by default
    }
}

// Check if the selected offer is valid (i.e., if it has a choice option, ensure one is selected)
function isOfferValid() {
  // console.log(
  //   selectedOffer.value, 'selected Offer', 
  //   selectedChoice.value, 'singular option', 
  //   selectedMultipleChoice.value, 'multiple options'
  // );

  const { choiceOption, selectOption } = selectedOffer.value || {};
  const hasSelection = selectedChoice.value || (selectedMultipleChoice.value?.length > 0);

  // console.log(
  //   selectedOffer.value && (choiceOption && hasSelection),
  //   'final',
  //   hasSelection,
  //   'option'
  // );

  return (
    selectedOffer.value &&
    (
      (!choiceOption && !selectOption) ||
      ((choiceOption || selectOption) && hasSelection)
    )
  );
}

// Grouping function to count occurrences of product codes
function groupByProductCode(offerList) {
  return offerList.reduce((acc, item) => {
        const code = item.product_code;
        if (!acc[code]) {
            acc[code] = [];
        }
        acc[code].push(item);
        return acc;
    }, {});
}
// Apply selected offer
async function applySelectedOffer() {
  disableBtn.value=true;
  setTimeout(disableBtn.value=false,2000);
  try {
    if(userAppliedOffer.value!=1 || !userAppliedOffer.value){
      // alert('Offer Already Applied');
      // console.log(cartStore.cartItems,'from applied selected offer');
      cartStore.removeItemOffers();
    }
    const cartinfo = cartItems.value.map((item)=>{
          return {
        "product_code": item.detail.product_id,
        "unitRate": parseInt(getUpdatedPrice(item)),
        // "unitRate": parseFloat(getUpdatedPrice(item)).toFixed(2),
        "unitPv": item.detail?.cv?0:parseInt(Number(item.detail.pv)),
        "quantity": Number(item.quantity),
        "totalAmount": parseInt(getUpdatedPrice(item) * Number(item.quantity)),
        // "totalAmount": parseFloat(getUpdatedPrice(item) * Number(item.quantity)).toFixed(2),
        "totalPv":parseInt(item.detail?.cv?0:parseInt(Number(item.detail.pv)) * Number(item.quantity))
          }
      })
  
    const payload = {
      mca_no: mca_no.value,
      cart_info: cartinfo,
      session_id: 'abc_12938jhj_sjdh_gj'||cartDetail.value.id,
      cart_offer: {
        offer_id: selectedOffer.value.offer_id,
        choice_option_id: selectedOffer.value.selectOption 
          ? (selectedMultipleChoice.value || null) 
          : (selectedOffer.value.choiceOption ? (selectedChoice.value || null) : null),
      }
    }
    const response = await offerService.ApplyOffer(payload);
    // Track the processed product codes to skip adding the first occurrence
    let processedProductCodes = {};
    if(response.status==200){
      const offerFinalList = response.data?.cart_info;
      response.data.cart_info.forEach((offerItem)=>{
        cartStore.setOffer(selectedOffer.value.offer_id);
        console.log(cartStore.getAppliedOffer,'from Pinia');
        console.log(selectedOffer.value.offer_id,'from button');
        const groupedOffers = groupByProductCode(offerFinalList);
    
        // Check if there are multiple occurrences of the product_code
        const relatedOffers = groupedOffers[offerItem.product_code];

        // Ignore the first item and add all subsequent items
          if (relatedOffers && relatedOffers.length > 1) {
          // Ensure only subsequent items are added, not the first
          if (!processedProductCodes[offerItem.product_code]) {
              // Mark the first occurrence as processed, don't add it
              processedProductCodes[offerItem.product_code] = 1;
          } else {
              // Add the subsequent items
              addItemToCart(offerItem);
          }
      } else {
          const product = cartItems.value.find(i=>i.detail.product_id==offerItem.product_code);
          if (product && offerItem.offer_code && offerItem.discount_percentage>0){
            updateDiscountedItemInCart(offerItem,product);
          } 
          else 
          if(product && offerItem.offer_code){
            addFreeItemToCart(offerItem);
          } 
          else if(!product && offerItem.offer_code && offerItem.discount_percentage>0){
            addItemToCart(offerItem);
          }else if(!product && offerItem.offer_code){
            addFreeItemToCart(offerItem);
          }else if(!product){
            addItemToCart(offerItem);
          }
        }
        
      })
      
      cartStore.setOfferMessage(response.data.statusMessage);


      showToast('xyz',{
        message:response.data.statusMessage,
        type:"info",
        duration:4000
      });
      
    }
    console.log("Offer applied successfully:", response);

  } catch (error) {
    console.error("Error applying offer:", error);
  }
  closeSidebar()
}
function addFreeItemToCart(item){
  cartStore.addToCart(item,true)
  // cartStore.addToCart({
  //   name: item.product_code,
  //   pv: item.unitPv,
  //   quantity: item.quantity||1,
  //   thumbnail:"",
  //   product_id: item.product_code,
  //   sku: item.product_code,
  //   dp: item.unitRate,
  //   price: item.unitRate,
  //   tax_category_id:0,
  //   used_points:0,
  //   cv:false
  // },true)
    console.log(item,'new product added');

  // cartStore.addToCart(item,true);
}
function addItemToCart(item){
  console.log('adding normal item from discount',item)

  cartStore.addToCart(item,false,true)
}
function updateDiscountedItemInCart(item,product){
      const base_price=Number(item.unitRate);
      const base_pv=Number(product.detail?.pv);
      const discountAmount = parseFloat(Number(item.unitRate) * Number(item.discount_percentage) / 100);
      let priceAfterDiscount = parseFloat(item.unitRate) - discountAmount;
      if(product.cv){
        priceAfterDiscount = parseFloat(item.unitRate);
      }
    const totalWithDiscount = priceAfterDiscount * Number(item.quantity);
    const taxAmount = (totalWithDiscount * Number(item.tax_percent) / 100);
    const finalTotal = totalWithDiscount + taxAmount;
      const updated = {
        ...product.detail,
        offer_code:item.offer_code,
        discount_percent: item.discount_percentage,
        base_discount_amount: Number(base_price)*(Number(item.discount_percentage)/100),
        dis_per_pv:item?.pv_percentage,
        dis_amt_pv:parseInt(Number(base_pv)*(Number(item.pv_percentage)/100)*item.quantity),
        base_dis_amt_pv:parseInt(Number(base_pv)*(Number(item.pv_percentage)/100)),
        base_price: base_price,
        price_after_discount: priceAfterDiscount,
        discount_amount: discountAmount,
        total_with_discount: totalWithDiscount,
        tax_amount: taxAmount,
        final_total: finalTotal
      }
      console.log(updated,'updatediscoutn',item,'item recieved',product,'real product')
      cartStore.updateCartItemDetails(product.product_id,updated,{},true)
}
// Close sidebar (using eventBus like in your previous components)
function closeSidebar() {
  if(eventBus.panelClose){
    eventBus.panelClose();
  }
  emit("closeEvent", true);
}
onMounted(async () => {
  // emit("closeEvent", false);
  try {
    const payload = cartItems.value
    .filter(item => !item.detail?.isFreeItem && !item.detail?.isAddedItem)
    .map((item)=>{
        return {
      "product_code": item.detail.product_id,
      "unitRate": parseInt(getUpdatedPrice(item)),
      // "unitRate": parseFloat(getUpdatedPrice(item)).toFixed(2),
      "unitPv": item.cv?0:parseInt(Number(item.detail.pv)),
      "quantity": Number(item.quantity),
      "totalAmount": parseInt(getUpdatedPrice(item) * Number(item.quantity)),
      // "totalAmount": parseFloat(getUpdatedPrice(item) * Number(item.quantity)).toFixed(2),
			"totalPv":parseFloat(item.cv?0:Number(item.detail.pv)) * Number(item.quantity)
        }
    });
    const response = await offerService.fetchOffers({
        mca_no: mca_no.value,
        cart_info:payload,
        session_id: 'abc_12938jhj_sjdh_gj'||cartDetail.value.id
    });
    if(response.status==200){
      // if(offers.value.length!=0){
      //   cartStore.setOfferModalStatus(1);
      // }
      offers.value = response.data.offers;
      if (props.validate === "firstCheck") {
        emit("update-promotion-count", promotionsCount.value);
      }
    }
  } catch (error) {
    console.error("Error fetching offers:", error);
  }
});

</script>

<style scoped>
.checkbox-container {
  margin: 1em 0;
}

.select-label {
  font-weight: bold;
  margin-bottom: 0.5em;
  display: block;
}

.checkbox-group {
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 6px;
  color: #276ca5;
  label{
  color:black;
  }
}

.checkbox-item {
  margin: 0.5em 0;
  display: flex;
  align-items: center;
}

input[type="checkbox"] {
  margin-right: 0.5em;
  width: 1.5em;
  height: 1.5em;
  cursor: pointer;
}

.checkbox-label {
  cursor: pointer;
  transition: color 0.3s;
  font-weight: 300 !important;
}

.checkbox-label:hover {
  color: #007BFF; /* Change color on hover */
}

.selected-options {
  margin-top: 1em;
  font-style: italic;
}
.sidebar-offerlist {
  padding: 15px;
  background-color: white;
  color: #276ca5; /* Text color */
}

.back-link {
  display: block;
  margin-bottom: 10px;
  color: #276ca5; /* Link color */
}

.offers-list {
  margin-bottom: 20px;
}

.offer-item {
  margin-bottom: 10px;
  border: 1px solid #276ca5; /* Border color for offers */
 display: flex;
 flex-direction: column;
 /* gap:10px; */
}
.offer-item .item {
  display: flex;
  /* justify-content: space-between; */
  flex-direction: row;
  padding: 0px 10px;
  gap: 10px;
  align-items: center;
  cursor: pointer;
  text-align: left;
}
.offer-item div:not(.item) {
  padding: 10px;
}
.offer-item div label {
  width: 100%;
  text-align:left;
}
.offer-selected {
  background-color: #276ca5; /* Highlight selected offer */
  color: white;
}
.offer-selected input {
  background-color: white;
  color: white;
  /* accent-color: white; */
  accent-color: #006ea5;
}

.apply-button-container {
  position: absolute;
  bottom: 15px;
  display: flex;
  justify-content: space-between;
  width:90%;
  /* left: 50%; */
  /* transform: translateX(-50%); */
}
.custom-apply-button-container {
  position: relative;
  bottom: 15px;
  display: flex;
  justify-content: space-between;
  width:100%;
  /* left: 50%; */
  /* transform: translateX(-50%); */
}

.btn-primary {
  background-color: #276ca5; /* Primary button color */
  border-color: #276ca5; /* Primary button border color */
}

.btn-primary:hover {
  background-color: #00306c; /* Darker shade for hover */
}

.btn-success {
  background-color: #5cb85c; /* Success button color */
}

.btn {
  width: 100%;
}
</style>
